// extracted by mini-css-extract-plugin
module.exports = {"form-text-info":"styles_form-text-info__2TLLL","yourEmail":"styles_yourEmail__2ADxr","email":"styles_email__BLvU3"};